let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("vlZ5n")).then(() => parcelRequire('i5MLu'));